import { combineReducers } from 'redux';
import { subscriptionsListReducer } from './subscriptionsList';
import { soldSubscriptionsReducer } from './soldSubscriptions';

export const subscriptionsReducer = combineReducers({
    subscriptions: subscriptionsListReducer,
    soldSubscriptions: soldSubscriptionsReducer,
});
